module.exports = __webpack_public_path__ + "c1654e0e36558ad0fcb462e89bfef68e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/landing_small_1.jpg
// module id = 1161
// module chunks = 0